<template>
  <div>
    <v-btn
      id="all-tiles-button"
      :disabled="selectResult.length == 0"
      @click="viewAllTiles()"
      outlined
    >
      View All Tiles
    </v-btn>
    <v-dialog v-model="dialog" @input="syncCart" fullscreen>
      <v-card>
        <v-card-title class="text-h5" style="background-color: rgb(57, 53, 53)">
          View All Tiles
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-responsive
          class="overflow-y-auto"
          style="max-height: calc(100vh - (70px + 76px))"
        >
          <div id="top"></div>
          <v-layout v-if="tiles_merged" justify-center row wrap>
            <div
              class="pa-4"
              v-for="match in this.paged_cells[this.page]"
              v-bind:key="`${match.acquisition_id}${match.cell_id}`"
            >
              <tile-preview
                :match="match"
                :cell_feature="cell_info[match.cell_id]"
              />
            </div>
          </v-layout>
        </v-responsive>

        <v-divider></v-divider>

        <v-card-actions>
          <v-layout justify-start class="mt-2">
            <v-row>
              <v-col cols="auto">
                <span>
                  Showing {{ tile_shown_min_count }} -
                  {{ Math.min(tile_shown_max_count, numberOfTiles) }} of
                  {{ numberOfTiles }} tiles
                </span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto">
                <v-row>
                  <v-col>
                    <v-btn
                      id="add-all-button"
                      outlined
                      :disabled="cartSelection.length == numberOfTiles"
                      @click="addAllToCart()"
                    >
                      Add all to cart
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      id="empty-button"
                      outlined
                      :disabled="cartSelection.length == 0"
                      @click="emptyCart()"
                    >
                      Empty Cart
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      id="all-tiles-cart-button"
                      color="primary"
                      outlined
                      @click="viewCart()"
                    >
                      <span> View Cart ({{ cartSize }})</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-spacer v-if="paged_cells.length > 1"></v-spacer>
              <v-col v-if="paged_cells.length > 1" cols="auto">
                <v-row>
                  <v-col>
                    <v-btn outlined :disabled="page === 0" @click="prevPage()">
                      Previous
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      outlined
                      :disabled="page == paged_cells.length - 1"
                      @click="nextPage()"
                    >
                      Next
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex-composition-helpers";
import { eventBus } from "@/main.ts";
import TilePreview from "./TilePreview.vue";
const cartStore = createNamespacedHelpers("shoppingCart");

export default {
  setup() {
    const { addToCart } = cartStore.useMutations(["addToCart"]);
    const { emptyStore } = cartStore.useMutations(["emptyStore"]);
    return { addToCart, emptyStore };
  },
  props: ["selectResult", "cell_features"],
  data() {
    return {
      tiles_merged: false,
      dialog: false,
      cartSelection: this.$store.state.shoppingCart.cart,
      merged_cells: [],
      paged_cells: [],
      cell_info: {},
      page: 0,
      tile_shown_min_count: 1,
      tile_shown_max_count: 100,
    };
  },
  components: { TilePreview },
  computed: {
    numberOfTiles() {
      let count = 0;
      this.selectResult.forEach((cell) => {
        count += cell.children.length;
      });
      return count;
    },
    store() {
      return this.$store.state.shoppingCart.cart;
    },
    cartSize() {
      return this.$store.state.shoppingCart.cart.length;
    },
  },
  watch: {
    store(newStore, oldStore) {
      this.cartSelection = this.$store.state.shoppingCart.cart;
    },
    cell_features: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if ("features" in newValue) {
          newValue.features.forEach((cell) => {
            this.merged_cells = this.merged_cells.concat(
              cell.properties.matches
            );
            this.cell_info[cell.properties.id] = cell;
          });
          while (this.merged_cells.length > 0) {
            this.paged_cells.push(this.merged_cells.splice(0, 100));
          }
          this.tiles_merged = true;
        }
      },
    },
    dialog: {
      immediate: true,
      deep: true,
      handler() {
        this.cartSelection = this.$store.state.shoppingCart.cart;
      },
    },
  },
  methods: {
    viewAllTiles() {
      this.dialog = true;
    },
    viewCart() {
      this.dialog = false;
      this.$emit("view_cart");
    },
    syncCart(e) {
      // send event to cell results component to sync checkbox selections
      this.cartSelection = this.$store.state.shoppingCart.cart;
      if (!e) {
        eventBus.$emit("syncCart", this.cartSelection);
      }
    },
    addAllToCart() {
      this.selectResult.forEach((cell) => {
        cell.children.forEach((tile) => {
          this.addToCart(tile);
        });
      });
      this.cartSelection = this.$store.state.shoppingCart.cart;
      eventBus.$emit("syncCart", this.cartSelection);
    },
    emptyCart() {
      this.cartSelection = [];
      this.emptyStore();
      eventBus.$emit("syncCart", this.cartSelection);
    },
    nextPage() {
      this.page += 1;
      this.tile_shown_min_count += 100;
      this.tile_shown_max_count += 100;
      // scroll view to top
      const element = document.getElementById("top");
      element.scrollIntoView();
    },
    prevPage() {
      this.page -= 1;
      this.tile_shown_min_count -= 100;
      this.tile_shown_max_count -= 100;
      // scroll view to top
      const element = document.getElementById("top");
      element.scrollIntoView();
    },
  },
};
</script>
